export default [
  {
    path: '/activity-20260618-main',
    component: () => import('./Page.vue'),
    meta: { title: '端午节', id: 33 },
  },
  {
    path: '/activity-20260618-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '端午节-规则', id: 33 },
  },
]
